import { useEffect, ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { useLocation } from "react-router-dom"
import ReactGA from "react-ga4"
import { GOOGLE_TRACKING_ID, NODE_ENV } from "config"

import { withCookieConsent } from "hocs/cookie"
import { CookieConsentType } from "types"

type Props = React.HTMLAttributes<HTMLDivElement> & {
  cookie: CookieConsentType
}

const TrackerComponent = ({ cookie }: Props) => {
  const location = useLocation()
  const { pathname, search } = location

  const { analytics } = cookie
  const isEnabled = NODE_ENV === "production" && GOOGLE_TRACKING_ID && analytics

  if (isEnabled && GOOGLE_TRACKING_ID) {
    ReactGA.initialize(GOOGLE_TRACKING_ID)
  }

  useEffect(() => {
    if (isEnabled) {
      ReactGA.send({ hitType: "pageview", page: pathname + search })
    }
  }, [location])

  return null
}

export default compose<ComponentType>(withCookieConsent)(TrackerComponent)
